export class InvoiceDetailProjectAppointmentListPresenter {
  constructor(result) {
    const {
      appointment_list: appointmentList
    } = result;

    return appointmentList.data.map(project => {
      return {
        id: project.project_id,
        name: project.project_name,
        months: project.date_groups.map(month => {
          return {
            fulfilledAtThaiDateText: month.fulfilled_at_thai_date,
            fulfilledYearMonth: month.fulfilled_year_month,
            homes: month.homes.map(home => {
              return {
                id: home.home_id,
                addressNo: home.address_no,
                appointments: home.appointments.map(appointment => {
                  return {
                    id: appointment.appointment_id,
                    serviceName: appointment.service_name,
                  }
                })
              }
            })
          };
        })
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/other-web/supplier/presenters/InvoiceDetailProjectAppointmentListPresenter.js